/**
 * Sprint 18 T18.3 — TR il/ilçe statik veri seti.
 *
 * **Kapsam (Sprint 18 Block A foundation):**
 * - 81 il (plaka + ad + bölge) — TAM.
 * - Top 10 büyükşehir ilçe listesi — TAM (İstanbul, Ankara, İzmir, Bursa,
 *   Antalya, Konya, Adana, Mersin, Gaziantep, Kocaeli).
 * - Geri kalan 71 il: ilçe listesi boş — `scripts/import-tr-districts.ts` ile
 *   TÜİK kaynağından enrich edilecek (Sprint 18 closure öncesi).
 *
 * **Veri kaynağı (otorite):**
 * - İl plakaları: T.C. İçişleri Bakanlığı (sabit, 1923'ten beri)
 * - İlçeler: TÜİK İdari Bölünüş Tablosu (yıllık güncellenir)
 *
 * @see https://www.e-devlet.gov.tr/ — il/ilçe listesi sorgu
 * @see apps/api/prisma/schema.prisma — `model CompanyAddress`
 */

export interface City {
  /** Plaka kodu (1-81). */
  plaka: number;
  /** İl adı (TR locale, başharf büyük). */
  name: string;
  /** Coğrafi bölge (Findeks + risk skoru analizi için). */
  region: Region;
  /** İlçe listesi (UI cascade dropdown). Boşsa enrichment bekliyor. */
  districts: ReadonlyArray<string>;
}

export type Region = 'Marmara' | 'Ege' | 'Akdeniz' | 'İç Anadolu' | 'Karadeniz' | 'Doğu Anadolu' | 'Güneydoğu Anadolu';

/**
 * 81 il × ilçe data. Top 10 büyükşehir tam, diğerleri TODO.
 * Sıra plaka koduna göre artan.
 */
export const CITIES: ReadonlyArray<City> = [
  {
    plaka: 1,
    name: 'Adana',
    region: 'Akdeniz',
    districts: [
      'Aladağ',
      'Ceyhan',
      'Çukurova',
      'Feke',
      'İmamoğlu',
      'Karaisalı',
      'Karataş',
      'Kozan',
      'Pozantı',
      'Saimbeyli',
      'Sarıçam',
      'Seyhan',
      'Tufanbeyli',
      'Yumurtalık',
      'Yüreğir',
    ],
  },
  { plaka: 2, name: 'Adıyaman', region: 'Güneydoğu Anadolu', districts: [] },
  { plaka: 3, name: 'Afyonkarahisar', region: 'Ege', districts: [] },
  { plaka: 4, name: 'Ağrı', region: 'Doğu Anadolu', districts: [] },
  { plaka: 5, name: 'Amasya', region: 'Karadeniz', districts: [] },
  {
    plaka: 6,
    name: 'Ankara',
    region: 'İç Anadolu',
    districts: [
      'Akyurt',
      'Altındağ',
      'Ayaş',
      'Bala',
      'Beypazarı',
      'Çamlıdere',
      'Çankaya',
      'Çubuk',
      'Elmadağ',
      'Etimesgut',
      'Evren',
      'Gölbaşı',
      'Güdül',
      'Haymana',
      'Kahramankazan',
      'Kalecik',
      'Keçiören',
      'Kızılcahamam',
      'Mamak',
      'Nallıhan',
      'Polatlı',
      'Pursaklar',
      'Sincan',
      'Şereflikoçhisar',
      'Yenimahalle',
    ],
  },
  {
    plaka: 7,
    name: 'Antalya',
    region: 'Akdeniz',
    districts: [
      'Akseki',
      'Aksu',
      'Alanya',
      'Demre',
      'Döşemealtı',
      'Elmalı',
      'Finike',
      'Gazipaşa',
      'Gündoğmuş',
      'İbradı',
      'Kaş',
      'Kemer',
      'Kepez',
      'Konyaaltı',
      'Korkuteli',
      'Kumluca',
      'Manavgat',
      'Muratpaşa',
      'Serik',
    ],
  },
  { plaka: 8, name: 'Artvin', region: 'Karadeniz', districts: [] },
  { plaka: 9, name: 'Aydın', region: 'Ege', districts: [] },
  { plaka: 10, name: 'Balıkesir', region: 'Marmara', districts: [] },
  { plaka: 11, name: 'Bilecik', region: 'Marmara', districts: [] },
  { plaka: 12, name: 'Bingöl', region: 'Doğu Anadolu', districts: [] },
  { plaka: 13, name: 'Bitlis', region: 'Doğu Anadolu', districts: [] },
  { plaka: 14, name: 'Bolu', region: 'Karadeniz', districts: [] },
  { plaka: 15, name: 'Burdur', region: 'Akdeniz', districts: [] },
  {
    plaka: 16,
    name: 'Bursa',
    region: 'Marmara',
    districts: [
      'Büyükorhan',
      'Gemlik',
      'Gürsu',
      'Harmancık',
      'İnegöl',
      'İznik',
      'Karacabey',
      'Keles',
      'Kestel',
      'Mudanya',
      'Mustafakemalpaşa',
      'Nilüfer',
      'Orhaneli',
      'Orhangazi',
      'Osmangazi',
      'Yenişehir',
      'Yıldırım',
    ],
  },
  { plaka: 17, name: 'Çanakkale', region: 'Marmara', districts: [] },
  { plaka: 18, name: 'Çankırı', region: 'İç Anadolu', districts: [] },
  { plaka: 19, name: 'Çorum', region: 'Karadeniz', districts: [] },
  { plaka: 20, name: 'Denizli', region: 'Ege', districts: [] },
  { plaka: 21, name: 'Diyarbakır', region: 'Güneydoğu Anadolu', districts: [] },
  { plaka: 22, name: 'Edirne', region: 'Marmara', districts: [] },
  { plaka: 23, name: 'Elazığ', region: 'Doğu Anadolu', districts: [] },
  { plaka: 24, name: 'Erzincan', region: 'Doğu Anadolu', districts: [] },
  { plaka: 25, name: 'Erzurum', region: 'Doğu Anadolu', districts: [] },
  { plaka: 26, name: 'Eskişehir', region: 'İç Anadolu', districts: [] },
  {
    plaka: 27,
    name: 'Gaziantep',
    region: 'Güneydoğu Anadolu',
    districts: ['Araban', 'İslahiye', 'Karkamış', 'Nizip', 'Nurdağı', 'Oğuzeli', 'Şahinbey', 'Şehitkamil', 'Yavuzeli'],
  },
  { plaka: 28, name: 'Giresun', region: 'Karadeniz', districts: [] },
  { plaka: 29, name: 'Gümüşhane', region: 'Karadeniz', districts: [] },
  { plaka: 30, name: 'Hakkari', region: 'Doğu Anadolu', districts: [] },
  { plaka: 31, name: 'Hatay', region: 'Akdeniz', districts: [] },
  { plaka: 32, name: 'Isparta', region: 'Akdeniz', districts: [] },
  {
    plaka: 33,
    name: 'Mersin',
    region: 'Akdeniz',
    districts: [
      'Akdeniz',
      'Anamur',
      'Aydıncık',
      'Bozyazı',
      'Çamlıyayla',
      'Erdemli',
      'Gülnar',
      'Mezitli',
      'Mut',
      'Silifke',
      'Tarsus',
      'Toroslar',
      'Yenişehir',
    ],
  },
  {
    plaka: 34,
    name: 'İstanbul',
    region: 'Marmara',
    districts: [
      'Adalar',
      'Arnavutköy',
      'Ataşehir',
      'Avcılar',
      'Bağcılar',
      'Bahçelievler',
      'Bakırköy',
      'Başakşehir',
      'Bayrampaşa',
      'Beşiktaş',
      'Beykoz',
      'Beylikdüzü',
      'Beyoğlu',
      'Büyükçekmece',
      'Çatalca',
      'Çekmeköy',
      'Esenler',
      'Esenyurt',
      'Eyüpsultan',
      'Fatih',
      'Gaziosmanpaşa',
      'Güngören',
      'Kadıköy',
      'Kağıthane',
      'Kartal',
      'Küçükçekmece',
      'Maltepe',
      'Pendik',
      'Sancaktepe',
      'Sarıyer',
      'Silivri',
      'Sultanbeyli',
      'Sultangazi',
      'Şile',
      'Şişli',
      'Tuzla',
      'Ümraniye',
      'Üsküdar',
      'Zeytinburnu',
    ],
  },
  {
    plaka: 35,
    name: 'İzmir',
    region: 'Ege',
    districts: [
      'Aliağa',
      'Balçova',
      'Bayındır',
      'Bayraklı',
      'Bergama',
      'Beydağ',
      'Bornova',
      'Buca',
      'Çeşme',
      'Çiğli',
      'Dikili',
      'Foça',
      'Gaziemir',
      'Güzelbahçe',
      'Karabağlar',
      'Karaburun',
      'Karşıyaka',
      'Kemalpaşa',
      'Kınık',
      'Kiraz',
      'Konak',
      'Menderes',
      'Menemen',
      'Narlıdere',
      'Ödemiş',
      'Seferihisar',
      'Selçuk',
      'Tire',
      'Torbalı',
      'Urla',
    ],
  },
  { plaka: 36, name: 'Kars', region: 'Doğu Anadolu', districts: [] },
  { plaka: 37, name: 'Kastamonu', region: 'Karadeniz', districts: [] },
  { plaka: 38, name: 'Kayseri', region: 'İç Anadolu', districts: [] },
  { plaka: 39, name: 'Kırklareli', region: 'Marmara', districts: [] },
  { plaka: 40, name: 'Kırşehir', region: 'İç Anadolu', districts: [] },
  {
    plaka: 41,
    name: 'Kocaeli',
    region: 'Marmara',
    districts: [
      'Başiskele',
      'Çayırova',
      'Darıca',
      'Derince',
      'Dilovası',
      'Gebze',
      'Gölcük',
      'İzmit',
      'Kandıra',
      'Karamürsel',
      'Kartepe',
      'Körfez',
    ],
  },
  {
    plaka: 42,
    name: 'Konya',
    region: 'İç Anadolu',
    districts: [
      'Ahırlı',
      'Akören',
      'Akşehir',
      'Altınekin',
      'Beyşehir',
      'Bozkır',
      'Cihanbeyli',
      'Çeltik',
      'Çumra',
      'Derbent',
      'Derebucak',
      'Doğanhisar',
      'Emirgazi',
      'Ereğli',
      'Güneysınır',
      'Hadim',
      'Halkapınar',
      'Hüyük',
      'Ilgın',
      'Kadınhanı',
      'Karapınar',
      'Karatay',
      'Kulu',
      'Meram',
      'Sarayönü',
      'Selçuklu',
      'Seydişehir',
      'Taşkent',
      'Tuzlukçu',
      'Yalıhüyük',
      'Yunak',
    ],
  },
  { plaka: 43, name: 'Kütahya', region: 'Ege', districts: [] },
  { plaka: 44, name: 'Malatya', region: 'Doğu Anadolu', districts: [] },
  { plaka: 45, name: 'Manisa', region: 'Ege', districts: [] },
  { plaka: 46, name: 'Kahramanmaraş', region: 'Akdeniz', districts: [] },
  { plaka: 47, name: 'Mardin', region: 'Güneydoğu Anadolu', districts: [] },
  { plaka: 48, name: 'Muğla', region: 'Ege', districts: [] },
  { plaka: 49, name: 'Muş', region: 'Doğu Anadolu', districts: [] },
  { plaka: 50, name: 'Nevşehir', region: 'İç Anadolu', districts: [] },
  { plaka: 51, name: 'Niğde', region: 'İç Anadolu', districts: [] },
  { plaka: 52, name: 'Ordu', region: 'Karadeniz', districts: [] },
  { plaka: 53, name: 'Rize', region: 'Karadeniz', districts: [] },
  { plaka: 54, name: 'Sakarya', region: 'Marmara', districts: [] },
  { plaka: 55, name: 'Samsun', region: 'Karadeniz', districts: [] },
  { plaka: 56, name: 'Siirt', region: 'Güneydoğu Anadolu', districts: [] },
  { plaka: 57, name: 'Sinop', region: 'Karadeniz', districts: [] },
  { plaka: 58, name: 'Sivas', region: 'İç Anadolu', districts: [] },
  { plaka: 59, name: 'Tekirdağ', region: 'Marmara', districts: [] },
  { plaka: 60, name: 'Tokat', region: 'Karadeniz', districts: [] },
  { plaka: 61, name: 'Trabzon', region: 'Karadeniz', districts: [] },
  { plaka: 62, name: 'Tunceli', region: 'Doğu Anadolu', districts: [] },
  { plaka: 63, name: 'Şanlıurfa', region: 'Güneydoğu Anadolu', districts: [] },
  { plaka: 64, name: 'Uşak', region: 'Ege', districts: [] },
  { plaka: 65, name: 'Van', region: 'Doğu Anadolu', districts: [] },
  { plaka: 66, name: 'Yozgat', region: 'İç Anadolu', districts: [] },
  { plaka: 67, name: 'Zonguldak', region: 'Karadeniz', districts: [] },
  { plaka: 68, name: 'Aksaray', region: 'İç Anadolu', districts: [] },
  { plaka: 69, name: 'Bayburt', region: 'Karadeniz', districts: [] },
  { plaka: 70, name: 'Karaman', region: 'İç Anadolu', districts: [] },
  { plaka: 71, name: 'Kırıkkale', region: 'İç Anadolu', districts: [] },
  { plaka: 72, name: 'Batman', region: 'Güneydoğu Anadolu', districts: [] },
  { plaka: 73, name: 'Şırnak', region: 'Güneydoğu Anadolu', districts: [] },
  { plaka: 74, name: 'Bartın', region: 'Karadeniz', districts: [] },
  { plaka: 75, name: 'Ardahan', region: 'Doğu Anadolu', districts: [] },
  { plaka: 76, name: 'Iğdır', region: 'Doğu Anadolu', districts: [] },
  { plaka: 77, name: 'Yalova', region: 'Marmara', districts: [] },
  { plaka: 78, name: 'Karabük', region: 'Karadeniz', districts: [] },
  { plaka: 79, name: 'Kilis', region: 'Güneydoğu Anadolu', districts: [] },
  { plaka: 80, name: 'Osmaniye', region: 'Akdeniz', districts: [] },
  { plaka: 81, name: 'Düzce', region: 'Karadeniz', districts: [] },
];

const CITY_BY_PLAKA = new Map<number, City>(CITIES.map((c) => [c.plaka, c]));
const CITY_BY_NAME = new Map<string, City>(CITIES.map((c) => [c.name.toLocaleLowerCase('tr-TR'), c]));

/** Dropdown için { plaka, name, region } listesi (alfabetik). */
export function getCitiesList(): ReadonlyArray<City> {
  return CITIES;
}

/** Plaka koduna göre il. Bulunamazsa `undefined`. */
export function getCityByPlaka(plaka: number): City | undefined {
  return CITY_BY_PLAKA.get(plaka);
}

/** İl adıyla arama (case-insensitive, TR locale). */
export function getCityByName(name: string): City | undefined {
  return CITY_BY_NAME.get(name.toLocaleLowerCase('tr-TR'));
}

/**
 * İlçe listesi. Cascade dropdown (il seçildikten sonra).
 * Boş array → enrichment bekliyor (TODO).
 */
export function getDistrictsForCity(plaka: number): ReadonlyArray<string> {
  return CITY_BY_PLAKA.get(plaka)?.districts ?? [];
}

/** Plaka kodu geçerli mi (1-81 arası). */
export function isValidPlaka(plaka: unknown): plaka is number {
  return typeof plaka === 'number' && Number.isInteger(plaka) && plaka >= 1 && plaka <= 81;
}

/**
 * Belirli bir il için ilçe geçerli mi (case-insensitive, TR locale).
 * Şehirde ilçe listesi boşsa permissive davranır (enrichment bekliyor).
 */
export function isValidDistrict(plaka: number, district: string): boolean {
  const city = CITY_BY_PLAKA.get(plaka);
  if (!city) return false;
  if (city.districts.length === 0) return true; // not yet enriched
  const needle = district.toLocaleLowerCase('tr-TR');
  return city.districts.some((d) => d.toLocaleLowerCase('tr-TR') === needle);
}

/** TR posta kodu — 5 haneli rakam (10000-99999 arası boyut kontrolü değil). */
export function isValidPostalCode(code: string): boolean {
  return /^\d{5}$/.test(code);
}
